import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from 'locales/en.json';
import ja from 'locales/ja.json';
import { handleErrorMessage } from 'helper';
import { getListLanguageByEnvironment } from 'api/resource';

i18n.use(initReactI18next).init({
  fallbackLng: 'ja',
  debug: false,
  supportedLngs: ['en', 'ja'],
  interpolation: {
    escapeValue: false,
  },
  resources: {
    ja: { translation: ja },
    en: { translation: en },
  },
});

export const setResourceI18n = async () => {
  try {
    const { data } = await getListLanguageByEnvironment();
    const listLanguage = Object.keys(data);
    listLanguage.forEach((language: any) => {
      i18n.addResourceBundle(language, 'translation', data[language], true, true);
    });
  } catch (error) {
    handleErrorMessage(error);
  }
};
